import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=06296f8c&scoped=true&"
import script from "./Loyalty.vue?vue&type=script&lang=ts&"
export * from "./Loyalty.vue?vue&type=script&lang=ts&"
import style0 from "./Loyalty.vue?vue&type=style&index=0&id=06296f8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06296f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VLayout,VTab,VTabs})
